import React from "react";
import { ShieldCheck } from "lucide-react";
import { SectionFrame } from "./SectionFrame";
import { StatusBadge } from "../../StatusBadge";

const inPeriod = (dateStr, period) => dateStr && dateStr.slice(0, 7) === period;

/** Monthly Record - Compliance section (spec item 9). Reuses the medical check record
 * already fetched by EmployeeProfilePage (only when the viewer holds MEDICAL permission -
 * this component is simply never rendered otherwise, so no medical detail is exposed to an
 * ordinary manager through Monthly Record). */
export const ComplianceSection = ({ medicalCheck, period }) => {
  if (!medicalCheck) {
    return (
      <div id="monthly-compliance-section" className="bg-white rounded-xl border border-slate-200 p-5" data-testid="monthly-compliance-section">
        <div className="flex items-center gap-2 mb-4"><ShieldCheck size={16} className="text-slate-500" /><p className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Compliance</p></div>
        <p className="text-sm text-slate-500" data-testid="monthly-compliance-empty">No medical check record has been created for this employee yet.</p>
      </div>
    );
  }
  const eventsInPeriod = (medicalCheck.completion_history || []).filter((h) => inPeriod(h.completed_date, period));
  return (
    <div id="monthly-compliance-section" className="bg-white rounded-xl border border-slate-200 p-5" data-testid="monthly-compliance-section">
      <div className="flex items-center gap-2 mb-4"><ShieldCheck size={16} className="text-slate-500" /><p className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Compliance</p></div>
      <div className="flex items-center justify-between mb-3">
        <p className="text-sm text-slate-600">Medical clearance status</p>
        <StatusBadge status={medicalCheck.status} />
      </div>
      {eventsInPeriod.length > 0 ? (
        eventsInPeriod.map((h, i) => (
          <p key={i} className="text-xs text-slate-500" data-testid={`monthly-compliance-event-${i}`}>Medical requirement completed {h.completed_date} - acknowledged {new Date(h.acknowledged_at).toLocaleDateString()}</p>
        ))
      ) : (
        <p className="text-sm text-slate-500" data-testid="monthly-compliance-no-event">No medical check event occurred during this period.</p>
      )}
      <p className="text-[11px] text-slate-400 mt-3">Next due (drop-dead date): {medicalCheck.next_due_date || "Not yet assigned"}</p>
    </div>
  );
};
